import * as React from 'react';

import { genPublicUrl } from 'libs/image';
import Spacer from 'components/atoms/Spacer';
import LazyImage from 'components/atoms/LazyImage';

import cs from './index.scss';

const imageUrl = 'https://s3.ap-northeast-1.amazonaws.com/gracia.tanp/illust/empty/kanozyo.png';

const EmptyNotificationMessage: React.FC = React.memo(() => (
  <div className={cs['empty-message']}>
    <Spacer size={36} />
    <div className={cs['image-container']}>
      <LazyImage
        src={genPublicUrl(imageUrl, 108 * 2)}
        width="108px"
        height="108px"
        fit="cover"
      />
    </div>
    <Spacer size={24} />
    <div className={cs['no-notification']}>まだお知らせはありません</div>
    <Spacer size={16} />
    <div className={cs['description']}>
      お得なクーポンや大切な方の記念日、
      <br />
      タンプからの重要なお知らせが表示されます。
    </div>
    <Spacer size={465} />
  </div>
));

EmptyNotificationMessage.displayName = 'EmptyNotificationMessage';

export default EmptyNotificationMessage;
